import { format, subMonths, } from 'date-fns';
/**
 * Simple object check.
 * @param item
 * @returns {boolean}
 */
export const isObject = (item) => (item && typeof item === 'object' && !Array.isArray(item));
/**
 * Deep merge two objects.
 */
export const mergeDeep = (target, ...sources) => {
    if (!sources.length) {
        return target;
    }
    const source = sources.shift();
    if (isObject(target) && isObject(source)) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) {
                    Object.assign(target, {
                        [key]: {},
                    });
                }
                mergeDeep(target[key], source[key]);
            }
            else {
                Object.assign(target, {
                    [key]: source[key],
                });
            }
        }
    }
    return mergeDeep(target, ...sources);
};
/**
 * 테스트 데이터 일괄 추가
 */
export const batchCreate = (count, makeItem, key, field) => {
    const tmp = [];
    for (let i = 0; i < count; i += 1) {
        const item = makeItem({
            [key]: i,
            [field]: i,
        });
        tmp.push(item);
    }
    return tmp;
};
/**
 * 데이터 일괄 추가
 * @param count 아이템 개수
 * @param createTargetModel 생성하고자 하는 모델
 * @param paramFunc 커스텀 하고자 하는 형태 함수
 * @returns
 */
export const makeBulkItem = (count, createTargetModel, paramFunc) => new Array(count)
    .fill(undefined)
    .map((_, i) => createTargetModel(paramFunc && paramFunc(i)));
/**
 * 임의의 배열 생성
 * @param count 아이템 개수
 * @returns
 */
export const makeArray = (count, data = undefined) => new Array(count).fill(data);
/**
 * 랜덤 정수가 나옴
 * 기본값으로 하면 0, 1. true false임
 * @param max 최대값. 3 넣으면 0,1,2 나옴
 * @param min 최소값. 0
 */
export const getRandomInt = (max = 2, min = 0) => Math.floor(Math.random() * (max - min + 1)) + min;
/**
 * 홀수 짝수 번갈아 나오는 함수.
 * @param startIsOdd true => 홀짝, false => 짝홀
 */
export const getOddEven = (startIsOdd = true) => {
    let isOdd = startIsOdd;
    return () => {
        const value = isOdd ? 1 : 2;
        isOdd = !isOdd;
        return value;
    };
};
/**
 * 랜덤 날짜 생성기
 * 오늘 기준 3달 전
 */
export const getRandomDate = (subMonth = 3, dateFormat = 'yyyy-MM-dd') => {
    const start = subMonths(new Date(), subMonth);
    const end = new Date();
    const randomTime = start.getTime() + Math.random() * (end.getTime() - start.getTime());
    return format(new Date(randomTime), dateFormat);
};
/**
 * 10보다 작으면 문자열 0을 추가한다.
 */
const addZero = (v) => (v < 10 ? `0${v}` : v);
/**
 * 시간대 리스트
 * ['09~10', '10~11' ... '07~08']
 * @param isExcludeTotal 합계 제외 여부 true => 제외, false (기본값) => 포함
 * @returns
 */
export const getHourList = (isExcludeTotal = false) => {
    const arrayHead = isExcludeTotal
        ? []
        : [
            '합계',
        ];
    // 9부터 23까지의 배열 생성
    const array1 = Array.from({
        length: 23 - 9 + 1,
    }, (_, i) => 9 + i);
    // 0부터 8까지의 배열 생성
    const array2 = Array.from({
        length: 9,
    }, (_, i) => i);
    // 두 배열을 붙이기
    return arrayHead
        .concat(array1, array2)
        .reduce((acc, hour) => {
        if (hour === '합계') {
            acc.push(hour);
        }
        else {
            acc.push(`${addZero(hour)}~${addZero(hour + 1)}`);
        }
        return acc;
    }, []);
};
/**
 * 월부터 일요일까지 배열 생성
 * @param isExcludeTotal 합계 제외 여부 true => 제외, false (기본값) => 포함
 * @returns
 */
export const getWeekList = (isExcludeTotal = false) => {
    const list = isExcludeTotal
        ? []
        : [
            {
                title: '합계',
                value: 'total',
            },
        ];
    list.push({
        title: '월',
        value: 'mon',
    }, {
        title: '화',
        value: 'tue',
    }, {
        title: '수',
        value: 'wed',
    }, {
        title: '목',
        value: 'thu',
    }, {
        title: '금',
        value: 'fri',
    }, {
        title: '토',
        value: 'sat',
    }, {
        title: '일',
        value: 'sun',
    });
    return list;
};
